import {t} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {sanitizeUrl} from '../../../../../libs/shared/helpers/src/browser/urlHelpers';
import {Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';
import {FloatingTextInput} from '../../../common/floatingBars/floatingTextInput';

/*
 * Props.
 */

export interface CommentComposerFormattingLinkEditorProps {
  shouldFocus: boolean;
  initialUrl: string | undefined;
  onUrlSelect: HandlerOf<string | undefined>;
  onRequestClose: Handler;
}

/*
 * Styles.
 */

const StyledFloatingTextInput = styled(FloatingTextInput)`
  color: ${(p) => p.theme.palette.blue.shade40};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const CommentComposerFormattingLinkEditor: FC<CommentComposerFormattingLinkEditorProps> = (props) => {
  const localize = useLocalize();

  const onValueSelect: HandlerOf<string> = (value) => {
    props.onUrlSelect(sanitizeUrl(value) || undefined);
  };

  return (
    <StyledFloatingTextInput
      placeholder={localize(t('formatting-link-urlplaceholder')`Insert link URL`)}
      shouldFocus={props.shouldFocus}
      initialValue={props.initialUrl || ''}
      onValueSelect={onValueSelect}
      onRequestClose={props.onRequestClose}
    />
  );
};
